import type { Session, SessionData } from "@agapi/mlc-core";
import { type CartStore } from "../stores";
import { getCommerce } from "../services";
import { getLocaleFromUrl } from "./locale.shared";
import type { InstanceStore } from "../stores/instance";

/**
 * Initializes the session by populating cart items and retrieving product data.
 * This function sets up the cart store and populates it with items from the session.
 * It also retrieves additional product data for each item in the cart.
 *
 * @param session - The session object containing cart information
 */
/**
 * Initializes the session by populating cart items and retrieving product data.
 */
export const initializeSession = (session: SessionData, cart: CartStore, instance: InstanceStore, url: URL) => {
  console.log('[cart-store] Populate items from session and retrieve product data');
  cart.setLoading(true); // Explicitly set to true even if it may already been set (e.g. initial state, when loading site first time)
  cart.clear();

  session.cart.discountCodes.forEach((code) => {
    // NOTICE! This looks weird, but it actually sets the value in an object using the d.code as key,
    // see more in the context file, we have a set() function that does it using d.code as key,
    // later on we might want to apply more discount codes, or discounts that will be hidden from the user
    cart.discountCode = code;
  });

  Promise.allSettled(session.cart.items.map(async (item) => {
    console.log('getProductVariant', item);
    const { item: variant } = await getCommerce(window.fetch).getProductVariant(item.sku, getLocaleFromUrl(url), { userId: 'none' });

    // TODO: Ugly, we probably want to store these attributes in brink as custom item attributes
    if (variant) {
      console.log('getProductVariant:commerce', variant);

      // Will not trigger any events (for GA, Loop54 and potentially other services) as we are adding the items directly to the array
      try {
        cart.items.push({
          id: item.id,
          sku: item.sku,
          handle: variant.handle,
          quantity: item.quantity,
          price: variant.price,
          name: variant.name,
          variantName: variant.name,
          stock: variant.stock,
          brand: variant.brand.name,
          brandHandle: variant.brand.handle,
          imageUrl: variant.images?.[0].url,
          imageAlt: variant.images?.[0].alt,
          category: variant.categories?.[0],
        });
      } catch (error) {
        console.error('getProductVariant:error', error);
      }
    }
  })).then(() => {
    console.log(`[cart-store] Cart has finished loading ${cart.items.length} ${cart.items.length > 1 ? 'items' : 'item'}`);
    cart.timestamp = Date.now();
    cart.sync();
  }).finally(() => {
    // Set up a broadcast channel to sync cart state with other tabs/windows
    console.log('[cart-store] Setting up broadcast channel to:', `agapi-bc-${session.id}`);
    instance.set(new BroadcastChannel(`agapi-bc-${session.id}`));

    cart.setLoading(false);
  });
}
